/**
 * Extracts a human-readable message from a normalized RTK Query error payload.
 *
 * @param {object|null|undefined} error - Error object from an RTK Query hook.
 * @param {string} [fallbackMessage] - Message used when the error carries none.
 * @returns {string} Displayable error message.
 */
export const getApiErrorMessage = (error, fallbackMessage = 'Error fetching data') => {
  const message = error?.data?.message ?? error?.error ?? error?.message;
  return typeof message === 'string' && message ? message : fallbackMessage;
};
